/*
 * @Author: mayanxia
 * @Date: 2022-05-07 15:58:54
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-01-02 17:23:37
 */

<template>
    <div class="card-container">
        <a-row :gutter="10">
            <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px">
                <a-card :bordered="false">
                    <!-- 查询区域 -->
                    <div class="table-page-search-wrapper">
                        <a-form layout="inline" @keyup.enter.native="searchQuery">
                            <a-row :gutter="24">
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('设备编号')">
                                    <j-input :placeholder="$t('输入设备编号模糊查询')" v-model="queryParam.deviceId"></j-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('设备名称')">
                                    <j-input :placeholder="$t('输入设备名称模糊查询')" v-model="queryParam.deviceName"></j-input>
                                    </a-form-item>
                                </a-col>

                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('命令标识')" >
                                        <a-select v-model="queryParam.cmd" :placeholder="$t('请选择命令标识')">
                                        <a-select-option v-for="(item,value) in cmdList"  :value="value" :key="value" :label="item" :title="item">
                                            {{item}}
                                        </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('通讯状态')">
                                        <a-select  v-model="queryParam.status" :placeholder="$t('请选择通讯状态')">
                                        <a-select-option :value="value" :key="value" v-for="(item,value) in reportStatusObj">
                                            {{$t(item)}}
                                        </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('查询创建时间')">
                                        <a-range-picker
                                        v-model="date"
                                        format="YYYY-MM-DD"
                                        :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                                        @change="onDateRangeChange"
                                        @ok="onOk"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                    <a @click="handleToggleSearch" style="margin-left: 8px">
                                        {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                                    </a>
                                    </span>
                                </a-col>
                            </a-row>
                        </a-form>
                    </div>
            <!-- table区域-begin -->
                    <div class="table-operator">
                        <a-button type="primary" icon="download" @click="handleExportXls($t('命令服务队列'))">{{ $t('导出') }}</a-button>
                    </div>
                    <div>
                        <span style="float:right;">
                            <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
                            <template slot="content">
                                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                                <a-row>
                                    <template v-for="item in defColumns">
                                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                                        <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                                    </template>
                                    </template>
                                </a-row>
                                </a-checkbox-group>
                            </template>
                            </a-popover>
                        </span>
                        <a-table
                            ref="table"
                            size="middle"
                            bordered
                            rowKey="id"
                            :columns="columns"
                            :dataSource="dataSource"
                            :pagination="ipagination"
                            :loading="loading"
                            :scroll="{x: true}"
                            class="j-table-force-nowrap"
                            @change="handleTableChange">
                            <div slot="filterDropdown">
                            <a-card>
                                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                                <a-row>
                                    <template v-for="item in defColumns">
                                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                                        <a-col :span="12" :key="item.key">
                                        <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                                        </a-col>
                                    </template>
                                    </template>
                                </a-row>
                                </a-checkbox-group>
                            </a-card>
                            </div>
                            <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
                            <span slot="action" slot-scope="text, record">
                            <!-- <a @click="handleDetail(record)">详情</a> -->
                            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                            <a-divider type="vertical" />
                            <a :disabled="['1','2','3','4','-1'].includes(record.status)"  @click="cancel(record)">{{ $t('取消') }}</a>
                            </span>
                        </a-table>
                    </div>
                    <!-- table区域-end -->
                    <part-valve-service-queue-modal ref="modalForm" @ok="modalFormOk"></part-valve-service-queue-modal>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {isUndefined} from'@/utils/validate'
  import PartValveServiceQueueModal from './modules/PartValveServiceQueueModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import JInput from '@/components/jeecg/JInput'
  import { getAction,putAction } from '@/api/manage'
  import Vue from 'vue'
  import {reportStatusObj} from '@/utils/constants/protocolConstant'
  export default {
    name: "PartValveServiceQueueList",
    mixins:[JeecgListMixin,AreaChoosetMixin],
    components: {
      PartValveServiceQueueModal,
      JInput
    },
    data () {
      return {
        description: '命令队列',
        date:[],
        beginDate: null,
        endDate: null,
        endOpen: false,
        columns:[],
        collapsed: true,
        reportStatusObj,
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/part/partValveCommand/list",
          delete: "/jeecg-charge/part/partValveCommand/delete",
          deleteBatch: "/jeecg-charge/part/partValveCommand/deleteBatch",
          exportXlsUrl: "/jeecg-charge/part/partValveCommand/exportXls",
          importExcelUrl: "/jeecg-charge/part/partValveCommand/importExcel",
          cancel:"/jeecg-charge/part/partValveCommand/cancel"
        },
        dateType: 2
      }
    },
    created() {
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：命令标识选项使用 computed 以响应语言切换
      cmdList() {
        return {'8110_01': this.$t('读取采集器NB网络参数'),'8105_01': this.$t('读取上传间隔'),'8104_01': this.$t('读取自动上传时间点'),'8110_04': this.$t('设置采集器NB网络参数'),'a02a_04': this.$t('设置阀门角度'),'a029_04': this.$t('阀门角度校正'),'8105_04': this.$t('设置上传间隔'),'8104_04': this.$t('设置自动上传时间点'),'a017_04': this.$t('设置采集器阀门控制')}
      },
      // i18n：表头使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName'
          },{
            title: this.$t('安装位置'),
            align:"center",
            dataIndex: 'deviceLocation'
          },{
            title: this.$t('命令标识'),
            align:"center",
            dataIndex: 'cmd',
            customRender: (text,record) => {
                if(!isUndefined(this.cmdList[text])) {
                    return this.cmdList[text];
                }
                return this.$t('未知');
            }
          },{
            title: this.$t('通讯状态'),
            align:"center",
            dataIndex: 'status',
            customRender: (t,r,index) => {
              let data = this.reportStatusObj
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            }
          },{
            title: this.$t('发送时间'),
            align:"center",
            dataIndex: 'sendTime'
          },{
            title: this.$t('回应时间'),
            align:"center",
            dataIndex: 'receiveTime'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
        loadData(arg) {
            if(!this.url.list){
                this.$message.error(this.$t("请设置url.list属性!"))
                return
            }
            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
                this.ipagination.current = 1;
            }
            var params = this.getQueryParams();//查询条件

            this.loading = true;
            getAction(this.url.list, params).then((res) => {
                if (res.success) {
                this.dataSource = res.result.records;
                this.ipagination.total = res.result.total;
                }
                if(res.code===510){
                this.$message.warning(res.message)
                }
                this.loading = false;
            })
        },
      changeTab() {

      },
      cancel(record) {   //取消点击事件
        let _this= this
        this.$confirm({
          title: this.$t('你确定要撤销该条记录吗?'),
          content: h => <div style="color:red;"></div>,
          onOk() {
            _this.revocation(record)
          },
          onCancel() {
          }
        });
      },
      revocation(record) {    //取消操作
        const that = this;
        let data = {};
        // params.id = record.id
        data.id = record.id
        putAction(this.url.cancel+'?id='+record.id, {}).then((res)=>{
            if(res.success&&res.code === 0){
              that.$message.success(res.message);
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            this.loadData();
          })
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      onOk(value) {
        console.log('onOk: ', value);
      }
    }
  }
</script>
<style scoped>
  .card-container {
  overflow: hidden;
}
.card-container /deep/ .ant-tabs-content {
  margin-top: -16px;
}
.card-container /deep/ .ant-tabs-bar {
  background-color: #fff;
}

.card-container /deep/  .ant-tabs-content  .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container /deep/  .ant-tabs-bar {
}

.card-container /deep/  .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container /deep/ .ant-tabs-bar .ant-tabs-tab-active {
  background: #fff;
}
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>
